/* AMBRA-CUSTOM (wishlista) — widok "Ulubione" zbudowany z prawdziwych kafelkow listingu.
   Ladowany TYLKO na /a/wishlist-hero/* (snippets/ambra-wishlist-page.liquid).
   Zrodlo pozycji: lista wyrenderowana przez aplikacje Wishlist Hero (nie ruszamy aplikacji).
   Kafelki: Section Rendering API -> sections/ambra-wishlist-card.liquid (ten sam snippet co listing).
   Usuwanie/czyszczenie: oficjalne SDK aplikacji (window.WishListHero_SDK). Koszyk: /cart/add.js + eventBus motywu. */
(function () {
  'use strict';
  if (window.__ambraWishlistInit) return;
  window.__ambraWishlistInit = true;

  var cfgEl = document.getElementById('ambra-wl-config');
  var CFG = { loggedIn: false, loginUrl: '/account/login', cartUrl: '/cart', cartAddUrl: '/cart/add', sectionId: 'ambra-wishlist-card', thresholds: [] };
  try { if (cfgEl) CFG = Object.assign(CFG, JSON.parse(cfgEl.textContent)); } catch (e) { /* zostaja domyslne */ }

  var IS_SHARED = window.location.pathname.indexOf('/wishlist/shared/') !== -1;
  var APP_VIEW_SEL = '#wishlist-hero-shared-list-view';
  var APP_CARD_SEL = '.wishlist-hero-list-card';
  /* AMBRA-RO: teksty z konfiguracji (tylko w jezyku innym niz glowny jezyk sklepu); w PL dotychczasowe napisy */
  var T = CFG.t || {};
  function tx(k, d) { return (T[k] !== undefined && T[k] !== null && T[k] !== '') ? T[k] : d; }
  var APP_EMPTY_TEXT = tx('app_empty', 'Nie ma żadnych pozycji');

  var ICON = {
    trash: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/><path d="M10 11v6M14 11v6"/></svg>',
    share: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>',
    user: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"/></svg>'
  };

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmtMoney(cents) {
    var sample = String(CFG.money), i0 = -1, i1 = -1;
    for (var i = 0; i < sample.length; i++) { var c = sample.charCodeAt(i); if (c >= 48 && c <= 57) { if (i0 < 0) i0 = i; i1 = i; } }
    var v = Math.round(Number(cents) || 0);
    if (i0 < 0) return (v / 100).toFixed(2);
    var pre = sample.slice(0, i0), post = sample.slice(i1 + 1), num = sample.slice(i0, i1 + 1);
    var hasDec = num.replace(/\D/g, '') === '123456789', decSep = hasDec ? num.charAt(num.length - 3) : '';
    var intS = hasDec ? num.slice(0, num.length - 3) : num, th = intS.match(/\D+/), thSep = th ? th[0] : '';
    v = Math.abs(v); var ip = hasDec ? Math.floor(v / 100) : Math.round(v / 100), fp = String(v % 100); if (fp.length < 2) fp = '0' + fp;
    return pre + String(ip).replace(/\B(?=(\d{3})+(?!\d))/g, thSep) + (hasDec ? decSep + fp : '') + post;
  }
  function fmt(n) { if (CFG.money) return fmtMoney(Math.round(n * 100)); return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function plural(n) {
    if (T.count_other) {
      var cat = 'other';
      try { cat = new Intl.PluralRules(CFG.locale || undefined).select(n); } catch (e) { }
      return T['count_' + cat] || T.count_other;
    }
    return n === 1 ? 'produkt' : (n >= 2 && n <= 4 ? 'produkty' : 'produktów');
  }

  /* ---------- 1. czekamy, az aplikacja wyrenderuje liste ---------- */
  function sdkCount() {
    try { var S = window.WishListHero_SDK; var it = S && S.GetWishListItems ? S.GetWishListItems() : null; return it ? it.length : -1; } catch (e) { return -1; }
  }
  function waitForApp(cb) {
    var tries = 0, emptySince = 0;
    (function tick() {
      var view = document.querySelector(APP_VIEW_SEL);
      var cards = view ? view.querySelectorAll(APP_CARD_SEL) : [];
      var empty = view && (view.textContent.indexOf(APP_EMPTY_TEXT) !== -1 || (CFG.locale && sdkCount() === 0));
      if (view && cards.length) return cb(view, cards);
      if (view && empty) {
        /* aplikacja pokazuje "pusta" takze PRZED dociagnieciem listy z serwera — czekamy, az SDK potwierdzi pustke (albo 3 s) */
        if (!emptySince) emptySince = Date.now();
        var n = sdkCount();
        if (n === 0 || (!IS_SHARED && n < 0 && Date.now() - emptySince > 3000) || Date.now() - emptySince > 8000) return cb(view, cards);
      }
      if (++tries < 150) setTimeout(tick, 200); /* max 30 s; po tym zostaje widok aplikacji */
    })();
  }

  /* ---------- 2. pozycje listy (DOM aplikacji + SDK dla id wariantu) ---------- */
  function readItems(cards) {
    var sdkItems = [];
    try { if (window.WishListHero_SDK && window.WishListHero_SDK.GetWishListItems) sdkItems = window.WishListHero_SDK.GetWishListItems() || []; } catch (e) { sdkItems = []; }
    var items = [];
    for (var i = 0; i < cards.length; i++) {
      var a = cards[i].querySelector('a.wishlist-hero-list-card-header-product-name');
      var href = a ? a.getAttribute('href') || '' : '';
      var hm = href.match(/\/products\/([^?#]+)/);
      if (!hm) continue;
      var vm = href.match(/[?&]variant=(\d+)/);
      var name = a ? a.textContent.trim() : '';
      var it = { i: i, handle: hm[1], variantId: vm ? vm[1] : null, name: name, url: '/products/' + hm[1] + (vm ? '?variant=' + vm[1] : ''), sdk: null, removed: false, inCart: false };
      for (var k = 0; k < sdkItems.length; k++) {
        var s = sdkItems[k] || {};
        var sh = String(s.ProductHandle || s.productHandle || '');
        var link = String(s.ProductLink || s.productLink || '');
        var sv = String(s.ProductVariantId || s.productVariantId || '');
        var sameProduct = sh === it.handle || link.indexOf('/products/' + it.handle) !== -1;
        if ((it.variantId && sv === it.variantId) || (!it.variantId && sameProduct)) { it.sdk = s; break; }
      }
      items.push(it);
    }
    return items;
  }

  /* ---------- 3. kafelek z listingu (Section Rendering API) ---------- */
  var WL_ROOT = ((window.Shopify || {}).routes || {}).root || '/';
  var WL_CK = 'ambraWlCards' + (WL_ROOT !== '/' || CFG.money ? ':' + WL_ROOT + ':' + (CFG.money || '') : '');
  var cardCache = {};
  try { cardCache = JSON.parse(sessionStorage.getItem(WL_CK) || '{}'); } catch (e) { cardCache = {}; }

  function fetchCard(it) {
    if (cardCache[it.handle]) return Promise.resolve(cardCache[it.handle]);
    return fetch(WL_ROOT + 'products/' + it.handle + '?section_id=' + encodeURIComponent(CFG.sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pc = doc.querySelector('product-card');
        var out = pc ? pc.outerHTML : '';
        if (out) { cardCache[it.handle] = out; try { sessionStorage.setItem(WL_CK, JSON.stringify(cardCache)); } catch (e) { /* brak miejsca — bez cache */ } }
        return out;
      })
      .catch(function () { return ''; });
  }

  function variantFromCard(cardEl, it) {
    /* dane wariantu z /products/<handle>.js (cena wybranej pojemnosci) */
    return fetch(WL_ROOT + 'products/' + it.handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return null;
        var v = null, i;
        for (i = 0; i < p.variants.length; i++) { if (String(p.variants[i].id) === String(it.variantId)) v = p.variants[i]; }
        /* aplikacja czasem zapisuje pojemnosc tylko w nazwie ("... - 35ml"), bez ?variant= w linku */
        var nm = it.name.match(/-\s*(\d+)\s*ml\s*$/i);
        if (!v && nm) { for (i = 0; i < p.variants.length; i++) { if (String(p.variants[i].title).replace(/\s+/g, '').toLowerCase() === nm[1] + 'ml') v = p.variants[i]; } if (v) it.variantId = String(v.id); }
        if (!v) v = p.variants[0];
        return { id: v.id, title: String(v.title || '').replace(/\s+/g, ' ').trim().replace(/^(\d+)\s*ml$/i, '$1 ml'), price: v.price / 100, cmp: v.compare_at_price ? v.compare_at_price / 100 : null, available: !!v.available, productId: p.id };
      })
      .catch(function () { return null; });
  }

  /* ---------- 4. budowa widoku ---------- */
  var root, items = [], cartVariantIds = {};

  function buildCard(it, html, v) {
    var host = document.createElement('div');
    host.className = 'awl-card';
    host.setAttribute('data-i', it.i);
    host.innerHTML = html;
    var pc = host.querySelector('product-card');
    if (!pc) return host;
    pc.removeAttribute('data-animate');
    var junk = pc.querySelectorAll('theme-modal, safe-load-scripts');
    for (var j = 0; j < junk.length; j++) junk[j].parentNode.removeChild(junk[j]);

    /* nazwa jak w aplikacji: "416. Perfumy Ambra Classic - 35ml" gdy klient dodal wariant */
    var tl = pc.querySelector('.product-grid--title a');
    if (tl && it.name) { tl.textContent = it.name; tl.setAttribute('href', it.url); }

    /* cena wybranej pojemnosci (zamiast "od ...") — tylko gdy na liscie jest konkretny wariant */
    if (it.variantId && v) {
      var pw = pc.querySelector('.ambra-price-wrap');
      if (pw) {
        var from = pw.querySelectorAll('.price--from-text');
        for (var f = 0; f < from.length; f++) from[f].parentNode.removeChild(from[f]);
        var sale = pw.querySelector('.product-price--sale'), reg = pw.querySelector('.product-price--regular');
        if (v.cmp && v.cmp > v.price) {
          if (sale) { sale.classList.remove('hidden'); var sp = sale.querySelector('.price--sale-price'); if (sp) sp.textContent = fmt(v.price); var ce = sale.querySelector('.price--compare-at-price'); if (ce) ce.innerHTML = '<span class="visually-hidden">' + esc(tx('regular_price', 'Cena regularna')) + '</span>' + fmt(v.cmp); }
          if (reg) reg.classList.add('hidden');
        } else {
          if (reg) { reg.classList.remove('hidden'); var rp = reg.querySelector('.price--regular-price'); if (rp) rp.textContent = fmt(v.price); }
          if (sale) sale.classList.add('hidden');
        }
      }
    }

    var vid = v ? String(v.id) : it.variantId;
    it.inCart = !!(vid && cartVariantIds[vid]);
    var label = v && !v.available ? esc(tx('out_of_stock', 'Brak w magazynie')) : esc(tx('add_to_cart', 'Dodaj do koszyka')) + (v ? ' · ' + esc(v.title) : '');
    var under = document.createElement('div');
    under.className = 'awl-under';
    under.innerHTML = '<div class="awl-ctarow">' +
      '<button type="button" class="awl-cta' + (it.inCart ? ' is-done' : '') + '" data-add="' + esc(vid || '') + '" data-i="' + it.i + '"' + (v && !v.available ? ' disabled' : '') + '>' + (it.inCart ? esc(tx('in_cart', 'W koszyku ✓')) : label) + '</button>' +
      (IS_SHARED ? '' : '<button type="button" class="awl-remove" data-remove data-i="' + it.i + '" aria-label="' + esc(tx('remove', 'Usuń z ulubionych')) + '" title="' + esc(tx('remove', 'Usuń z ulubionych')) + '">' + ICON.trash + '</button>') +
      '</div>';
    var wrapper = pc.querySelector('.grid-view-item-wrapper') || pc;
    wrapper.appendChild(under);
    return host;
  }

  function headHtml(count) {
    var actions = '<button type="button" class="btn" data-share>' + ICON.share + ' ' + esc(tx('share', 'Udostępnij listę')) + '</button>' +
      (IS_SHARED ? '' : '<button type="button" class="btn" data-clear>' + ICON.trash + ' ' + esc(tx('clear', 'Wyczyść listę')) + '</button>');
    var login = (!CFG.loggedIn && !IS_SHARED) ? '<p class="awl-login">' + ICON.user + '<span>' + esc(tx('login_before', 'Lista jest zapisana w tej przeglądarce.')) + ' <a href="' + esc(CFG.loginUrl) + '">' + esc(tx('login_link', 'Zaloguj się')) + '</a>' + esc(tx('login_after', ', żeby mieć ją też na innych urządzeniach.')) + '</span></p>' : '';
    return '<div class="awl-head"><div><h1>' + esc(tx('title', 'Ulubione')) + '<small>' + count + ' ' + plural(count) + '</small></h1>' + login + '</div><div class="awl-actions">' + actions + '</div></div>';
  }

  function emptyHtml() {
    return '<div class="awl-empty"><h2>' + esc(tx('empty_title', 'Twoja lista jest pusta')) + '</h2><p>' + esc(tx('empty_text', 'Dodawaj zapachy serduszkiem na kartach produktów — wrócisz do nich tutaj.')) + '</p>' +
      '<a class="btn" href="' + esc(tx('url_best', '/collections/bestsellery')) + '">' + esc(tx('empty_best', 'Zobacz bestsellery')) + '</a><a class="btn btn--secondary" href="' + esc(tx('url_quiz', '/pages/znajdz-zapach?src=wishlist')) + '">' + esc(tx('empty_quiz', 'Znajdź swój zapach')) + '</a></div>';
  }

  function live() { return items.filter(function (i) { return !i.removed; }); }

  function sumBarHtml() {
    var L = live();
    if (!L.length) return '';
    var inCart = L.filter(function (i) { return i.inCart; });
    if (!inCart.length) {
      return '<div class="awl-sum"><div class="awl-sum__l"><span>' + esc(tx('sum_hint', 'Wrzuć coś do koszyka — tu zobaczysz sumę')) + '</span><small>' + CFG.thresholds.map(function (t) { return esc(t.label) + ' ' + esc(tx('from', 'od')) + ' ' + (CFG.money ? fmt(t.at) : t.at + ' zł'); }).join(' · ') + '</small></div>' +
        '<button type="button" class="awl-cta" data-add-all>' + esc(tx('add_all', 'Dodaj wszystko')) + ' (' + L.length + ')</button></div>';
    }
    var sum = inCart.reduce(function (s, i) { return s + (i.v ? i.v.price : 0); }, 0);
    var next = null;
    for (var t = 0; t < CFG.thresholds.length; t++) { if (sum < CFG.thresholds[t].at) { next = CFG.thresholds[t]; break; } }
    var line = next ? esc(tx('missing', 'Brakuje')) + ' <b>' + fmt(next.at - sum) + '</b> ' + esc(tx('missing_to', 'do:')) + ' ' + esc(next.label) : esc(tx('all_benefits', '✓ Masz komplet korzyści'));
    return '<div class="awl-sum"><div class="awl-sum__l"><span>' + esc(tx('in_cart_from_list', 'W koszyku z listy:')) + ' <b>' + inCart.length + '</b> · <b>' + fmt(sum) + '</b></span><small>' + line + '</small></div>' +
      '<a class="awl-cta" href="' + esc(CFG.cartUrl) + '">' + esc(tx('go_to_cart', 'Do koszyka →')) + '</a></div>';
  }

  function renderShell() {
    var L = live();
    root.innerHTML = headHtml(L.length) + (L.length ? '<div class="awl-grid"></div>' : emptyHtml()) + sumBarHtml();
  }

  function refreshSum() {
    var old = root.querySelector('.awl-sum');
    if (old) old.parentNode.removeChild(old);
    root.insertAdjacentHTML('beforeend', sumBarHtml());
    var h1s = root.querySelector('.awl-head h1 small');
    if (h1s) h1s.textContent = live().length + ' ' + plural(live().length);
  }

  /* ---------- 5. koszyk (jak w motywie: /cart/add.js + eventBus) ---------- */
  function refreshCartUI(response) {
    if (window.eventBus && typeof window.eventBus.emit === 'function') {
      window.eventBus.emit('update:cart:drawer', response);
      var pc = document.getElementById('PageContainer');
      if (pc && pc.dataset.cartAction === 'go_to_or_open_cart' && pc.dataset.cartType === 'drawer') window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
    }
    if (window.routes && window.routes.cart_url && window.wetheme && typeof window.wetheme.updateCartCount === 'function') {
      fetch(window.routes.cart_url + '?view=compare').then(function (r) { return r.json(); }).then(function (cart) { window.wetheme.updateCartCount(cart); }).catch(function () {});
    }
  }

  function addToCart(variantIds, done) {
    var ids = variantIds.filter(Boolean);
    if (!ids.length) return done(false);
    fetch(CFG.cartAddUrl + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), sections: 'cart-drawer' })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function (json) { ids.forEach(function (id) { cartVariantIds[String(id)] = true; }); refreshCartUI(json); done(true); })
      .catch(function (err) { if (window.console) console.error('AMBRA wishlista: blad dodawania do koszyka', err); done(false); });
  }

  function loadCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { cartVariantIds = {}; (c.items || []).forEach(function (li) { cartVariantIds[String(li.variant_id)] = true; }); })
      .catch(function () { cartVariantIds = {}; });
  }

  /* ---------- 6. usuwanie przez SDK aplikacji (z "Cofnij") ---------- */
  function sdk() { return window.WishListHero_SDK || null; }

  function removeItem(it) {
    var S = sdk();
    var vid = it.sdk ? (it.sdk.ProductVariantId || it.sdk.productVariantId) : it.variantId;
    if (!S || !S.DeleteWishListItem || !vid) { window.location.reload(); return; }
    var host = root.querySelector('.awl-card[data-i="' + it.i + '"]');
    if (host) host.classList.add('is-leaving');
    Promise.resolve(S.DeleteWishListItem({ ProductVariantId: Number(vid), WishlistHash: S.GetWishListHash() }))
      .then(function (res) {
        if (res && res.ok === false) throw res;
        it.removed = true;
        if (host && host.parentNode) host.parentNode.removeChild(host);
        if (!live().length) renderShell(); else refreshSum();
        showUndo(it);
      })
      .catch(function (err) { if (host) host.classList.remove('is-leaving'); if (window.console) console.error('AMBRA wishlista: blad usuwania', err); });
  }

  function undoRemove(it) {
    var S = sdk(), s = it.sdk;
    if (!S || !S.AddWishListItem || !s) { window.location.reload(); return; }
    var payload = {
      ProductId: Number(s.ProductId || s.productId), ProductVariantId: Number(s.ProductVariantId || s.productVariantId),
      ProductTitle: String(s.ProductTitle || s.ProductName || s.productTitle || it.name), ProductPrice: Number(s.ProductPrice || s.productPrice || s.Price || s.price || 0),
      ProductLink: String(s.ProductLink || s.productLink || (window.location.origin + it.url)), ProductImage: String(s.ProductImage || s.productImage || ''),
      WishlistHash: S.GetWishListHash()
    };
    var cid = S.GetCustomerId ? S.GetCustomerId() : null; /* SDK odrzuca null — klucz tylko dla zalogowanych */
    if (cid !== null && cid !== undefined && cid !== '' && !isNaN(Number(cid))) payload.CustomerId = Number(cid);
    Promise.resolve(S.AddWishListItem(payload)).then(function () { window.location.reload(); }).catch(function () { window.location.reload(); });
  }

  var undoEl, undoTimer;
  function showUndo(it) {
    if (!undoEl) { undoEl = document.createElement('div'); undoEl.id = 'ambra-wl-undo'; document.body.appendChild(undoEl); }
    var num = (it.name.match(/^\d+/) || [it.name])[0];
    undoEl.innerHTML = esc(tx('removed_before', 'Usunięto')) + ' <b>' + esc(num) + '</b> ' + esc(tx('removed_after', 'z ulubionych')) + ' <button type="button">' + esc(tx('undo', 'Cofnij')) + '</button>';
    undoEl.classList.add('is-visible');
    undoEl.querySelector('button').onclick = function () { undoEl.classList.remove('is-visible'); undoRemove(it); };
    clearTimeout(undoTimer);
    undoTimer = setTimeout(function () { undoEl.classList.remove('is-visible'); }, 10000);
  }

  function clearAll() {
    var S = sdk();
    if (!S || !S.DeleteAllWishListItems) return;
    if (!window.confirm(tx('confirm_clear', 'Usunąć wszystkie produkty z listy ulubionych?'))) return;
    Promise.resolve(S.DeleteAllWishListItems({ WishlistHash: S.GetWishListHash() })).then(function () { window.location.reload(); }).catch(function () { window.location.reload(); });
  }

  /* ---------- 7. zdarzenia ---------- */
  function wire() {
    root.addEventListener('click', function (e) {
      var t = e.target;
      var add = t.closest('[data-add]'), rm = t.closest('[data-remove]'), all = t.closest('[data-add-all]'), share = t.closest('[data-share]'), clear = t.closest('[data-clear]');
      if (add) {
        if (add.classList.contains('is-done') || add.disabled) return;
        var it = items[+add.getAttribute('data-i')];
        add.disabled = true;
        addToCart([add.getAttribute('data-add')], function (ok) {
          add.disabled = false;
          if (ok) { it.inCart = true; add.classList.add('is-done'); add.textContent = tx('in_cart', 'W koszyku ✓'); refreshSum(); }
        });
      } else if (rm) {
        removeItem(items[+rm.getAttribute('data-i')]);
      } else if (all) {
        all.disabled = true;
        var ids = live().map(function (i) { return i.v ? i.v.id : i.variantId; });
        addToCart(ids, function (ok) { if (ok) { live().forEach(function (i) { i.inCart = true; }); rebuildButtons(); refreshSum(); } else all.disabled = false; });
      } else if (share) {
        /* okno udostepniania aplikacji: klikamy jej wlasny (schowany) przycisk */
        var appShare = document.querySelector('.wishlist-hero-footer-share-btn');
        if (appShare) appShare.click(); else document.dispatchEvent(new Event('wishlist-hero-open-share-popup'));
      } else if (clear) {
        clearAll();
      }
    });
  }

  function rebuildButtons() {
    var btns = root.querySelectorAll('.awl-cta[data-add]');
    for (var i = 0; i < btns.length; i++) { var it = items[+btns[i].getAttribute('data-i')]; if (it && it.inCart) { btns[i].classList.add('is-done'); btns[i].textContent = tx('in_cart', 'W koszyku ✓'); } }
  }

  /* ---------- 8. start ---------- */
  function init(view, cards, rebuild) {
    items = readItems(cards);
    root = document.createElement('div');
    root.id = 'ambra-wl';
    view.parentNode.insertBefore(root, view); /* bezposredni rodzic (#__next aplikacji), nie #MainContent */
    wire();

    if (!items.length) { renderShell(); document.body.classList.add('ambra-wl-on'); return; }

    loadCart().then(function () {
      return Promise.all(items.map(function (it) {
        return Promise.all([fetchCard(it), variantFromCard(null, it)]).then(function (res) { it.html = res[0]; it.v = res[1]; });
      }));
    }).then(function () {
      var ok = items.filter(function (i) { return i.html; });
      if (!ok.length) return; /* kafelki sie nie pobraly — zostaje oryginalny widok aplikacji */
      items.forEach(function (i) { if (!i.html) i.removed = true; });
      items.forEach(function (it) { var vid = it.v ? String(it.v.id) : it.variantId; it.inCart = !!(vid && cartVariantIds[vid]); });
      renderShell();
      var grid = root.querySelector('.awl-grid');
      live().forEach(function (it) { grid.appendChild(buildCard(it, it.html, it.v)); });
      document.body.classList.add('ambra-wl-on');
    });
  }

  function signature(view) {
    var cards = view.querySelectorAll(APP_CARD_SEL), out = [];
    for (var i = 0; i < cards.length; i++) { var a = cards[i].querySelector('a.wishlist-hero-list-card-header-product-name'); out.push(a ? a.getAttribute('href') : ''); }
    return out.join('|');
  }
  function watchApp(view) {
    if (!('MutationObserver' in window)) return;
    var last = signature(view), timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var now = signature(view);
        if (now === last) return;
        last = now;
        if (root && root.parentNode) root.parentNode.removeChild(root);
        document.body.classList.remove('ambra-wl-on');
        init(view, view.querySelectorAll(APP_CARD_SEL), true);
      }, 400);
    }).observe(view, { childList: true, subtree: true });
  }
  function start() { waitForApp(function (view, cards) { init(view, cards); watchApp(view); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
